import { data } from "./data";
import BloodDonation from "./BloodDonation/BloodDonation";
import ChildDisability from "./ChildDisability/ChildDisability";
import RestForOvertimeWork from "./RestForOvertimeWork/RestForOvertimeWork";

import { isTerminal } from "../../../../../../../constants";
import {
    getReasonBelongsTypeThunkAction,
} from "../../../../../../../redux/actions/Requests/LeaveMetadata/thunk/getReasonBelongsType.thunk.action";
import ExtraVacationDaysApplication from "../../../../../../../frontend.classes/Requests/ExtraVacationDays.application";

import {
    dropdownSelectionCurrentRequest,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/dropdownSelection.currentRequest";
import {
    addCommentHandlerCurrentRequest,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/addCommentHandler.currentRequest";
import {
    clearAttachmentsAction,
} from "../../../../../../../redux/actions/Requests/Attachments/clearAttachments.action";
import {
    emptyCurrentRequest,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/emptyCurrentRequest";
import NotificationWindowRequests from "../../../../../../common/NotificationWindowRequests/NotificationWindowRequests";
import DropdownMenu from "../../../../../../common/Menu/DropdownMenu/DropdownMenu";

import {
    addExtraVacationInformationCurrentRequest,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/addBloodDonationInformation.currentRequest";
import {
    validationControlCurrentRequest,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/validationControl.currentRequest";
import {
    deleteAllAttachmentThunkAction,
} from "../../../../../../../redux/actions/Requests/Attachments/thunk/deleteAllAttachment.thunk.action";
import {
    isAttachmentsAllowedThunkAction,
    isAttachmentsAllowedWithReasonThunkAction,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/thunk/isAttachmentsAllowed.thunk.action";
import {
    clearAttachmentsAllowedAction,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/isAttachmentsAllowed.action";

import { ScrollButton } from "../../../../../../common/componentsTerminal/ScrollButton/ScrollButton";

import { useSearchParams } from "react-router-dom";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";

isTerminal ? import("./ExtraVacationDaysTerminal.scss") : import("./ExtraVacationDays.scss");

const ExtraVacationDays = (
    {
        setRequestStatus,
        requestStatus,
        requestOption,
        setRequestState,
    },
) => {

    const dispatch = useDispatch();

    const [searchParams] = useSearchParams();
    const queryId = searchParams.get("id");

    const reasons = useSelector(state => state.requests.reasons);
    const currentRequest = useSelector(state => state.requests.currentRequest);

    const [notificationWindow, setNotificationWindow] = useState(false);

    function selectDropdown(event, element, stateProperty) {
        if (currentRequest && currentRequest.attachments) {
            dispatch(deleteAllAttachmentThunkAction(currentRequest.attachments));
        } else {
            dispatch(deleteAllAttachmentThunkAction([]));
        }
        if(stateProperty === "leaveReasonId") {
            dispatch(emptyCurrentRequest(new ExtraVacationDaysApplication({
                leaveTypeId: 9,
                periods: [{ dateFrom: null, dateTo: null, loader: false }],
            })));
            dispatch(isAttachmentsAllowedWithReasonThunkAction(
                {
                    requestTypeId: requestOption,
                    reasonTypeId: element.id,
                }
            ));
        }
        dispatch(clearAttachmentsAction());
        dispatch(dropdownSelectionCurrentRequest({ event, element, stateProperty }));
    }

    function commentHandler(e) {
        dispatch(addCommentHandlerCurrentRequest(e.target.value));
    }


    function changeDateHandler(field, date, stateProperty) {
        dispatch(validationControlCurrentRequest(field, true));
        const value = moment(date).format("YYYY-MM-DD");
        dispatch(addExtraVacationInformationCurrentRequest({
            stateProperty: currentRequest && currentRequest.leaveReasonId === 34 ? "disabledChildCare" : "bloodDonationData",
            field: field,
            value: value,
        }));
    }

    function referenceHandler(e) {
        dispatch(validationControlCurrentRequest("certificateNumber", true));
        dispatch(addExtraVacationInformationCurrentRequest({
            stateProperty: currentRequest && currentRequest.leaveReasonId === 34 ? "disabledChildCare" : "bloodDonationData",
            field: "certificateNumber",
            value: e.target.value }));
    }
    function getReasonHelper(reason) {
        switch (reason) {
        case 34:
            return data.disabilityChildren;
        case 33:
            return data.bloodDonation;
        default:
            return "";
        }
    }
    useEffect(() => {
        setRequestStatus(false);
        dispatch(clearAttachmentsAction());
        dispatch(getReasonBelongsTypeThunkAction(requestOption));
        if (!queryId) {
            dispatch(emptyCurrentRequest(new ExtraVacationDaysApplication({
                leaveTypeId: 9,
                periods: [{ dateFrom: null, dateTo: null, loader: false }],
            })));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        if(queryId) {
            if (currentRequest && currentRequest?.leaveReasonId) {
                console.log(currentRequest?.leaveReasonId);
                dispatch(isAttachmentsAllowedWithReasonThunkAction(
                    {
                        requestTypeId: currentRequest.leaveTypeId,
                        reasonTypeId: currentRequest.leaveReasonId,
                    }
                ));
            }
        }  else {
            dispatch(isAttachmentsAllowedThunkAction({requestTypeId: requestOption }));
        }
        return () => {
            dispatch(clearAttachmentsAction());
            dispatch(clearAttachmentsAllowedAction());
        };
    }, [queryId]);

    useEffect(() => {
        if (requestStatus && !requestStatus.isSuccess) {
            setNotificationWindow(true);
        }
    }, [requestStatus]);


    return (
        <section className={"extra-vacation-days"}>
            {isTerminal && <ScrollButton />}
            <DropdownMenu
                disable={(!!queryId)}
                currentRequest={currentRequest}
                styleName={"reason"}
                label={<>Выберите причину предоставления дней отдыха <span className="required_text"> *</span></>}
                listOfOptions={reasons}
                stateProperty={"leaveReasonId"}
                helper={currentRequest && getReasonHelper(currentRequest.leaveReasonId)}
                isValidKey={
                    currentRequest
                    && currentRequest.isValid
                    && currentRequest.isValid.leaveReasonId
                        ? currentRequest.isValid.leaveReasonId
                        : false
                }
                selectOptionClick={selectDropdown} />

            {
                currentRequest && currentRequest.leaveReasonId === 33 ?
                    <BloodDonation
                        currentRequest={currentRequest}
                        setRequestState={setRequestState}
                        changeDateHandler= { changeDateHandler }
                        referenceHandler={referenceHandler}
                        commentHandler={commentHandler}
                    />
                    : null
            }
            {
                currentRequest && currentRequest.leaveReasonId === 34 ?
                    <ChildDisability
                        currentRequest={currentRequest}
                        setRequestState={setRequestState}
                        changeDateHandler= { changeDateHandler }
                        referenceHandler={referenceHandler}
                        commentHandler={commentHandler}
                        selectDropdown={selectDropdown}
                    />
                    : null
            }
            {
                currentRequest && currentRequest.leaveReasonId === 46 ?
                    <RestForOvertimeWork
                        currentRequest={currentRequest}
                        setRequestState={setRequestState}
                        changeDateHandler= { changeDateHandler }
                    />
                    : null
            }
            {
                currentRequest && currentRequest.leaveReasonId === 34  ||
                currentRequest && currentRequest.leaveReasonId === 33 ?
                    <div className={"extra-vacation-days__notification"}>
                        Обращаем внимание: для закрытия заявки будет необходимо предоставить
                        оригиналы документов в ОЦО (после получения соответствующего уведомления)
                    </div>
                    : null
            }

            <NotificationWindowRequests
                notificationWindowStatus={requestStatus}
                setNotificationWindowStatus={setRequestStatus}
                notificationWindowStyle={notificationWindow}
                blockingMessages={true}
            />
        </section>
    );
};

export default ExtraVacationDays;
